// Typelizer digest c52bea0cc2e493cbc443c2fab629d767
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /login */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/login', {}, options),
    method: 'get',
  }),

  /** POST /login */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/login', {}, options),
    method: 'post',
  }),

  /** DELETE /logout */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/logout', {}, options),
    method: 'delete',
  }),

  /** GET /login/verify */
  verify: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/login/verify', {}, options),
    method: 'get',
  }),

  /** POST /login/verify */
  confirm: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/login/verify', {}, options),
    method: 'post',
  }),

  /** GET /login/magic/:token */
  magicLink: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/login/magic/:token', params, options),
    method: 'get',
  }),
}
